var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"text-center",attrs:{"nav":"","color":"#2d2e40ee"}},[_c('v-list-item',[_c('v-list-item-title',{staticClass:"d-flex flex-column justify-center align-center"},[_c('b',{staticStyle:{"color":"#fff"}},[_vm._v("CMS")]),_c('v-divider')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }